module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Regular_201014-03fb4c117823472d2b5f496624656cd2.ttf";